<template>
  <div>
    <gj-table
        ref="gjTable"
        name="saleHotRank"
        :index="false"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :adapt-height="false"
        :height="534"
        row-id="id"
        :tree-config="{transform: false, lazy: true, hasChild: 'hasChild',loadMethod: loadChildrenMethod}"
    >

      <template v-slot:header:asin>
        <span v-if="type === 'asin'">ASIN</span>
        <span v-if="type === 'variationAsin'">父ASIN/子ASIN</span>
        <span v-if="type === 'msku'">MSKU</span>
      </template>

      <template v-slot:index="{row,index}">
        {{rank(row,index)}}
      </template>

      <template v-slot:picture="{row}">
        <app-dashboard-rank-picture-column
            :row="row"
            :groupType="type"
        ></app-dashboard-rank-picture-column>
      </template>

      <template v-slot:asin="{row}">
        <template v-if="type !== 'msku'">
          <gj-link v-if="row.hasChild" :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
          <gj-link v-else :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        </template>
        <span v-else>{{row.msku | defaultShow}}</span>
      </template>

      <template v-slot:salesGrossProfitRate="{row}">
        <span class="colorGreen">{{row.salesGrossProfitRate | defaultShow('','%')}}</span>
      </template>

      <template #empty v-if="!showStoreMask">
        <div></div>
      </template>

    </gj-table>
  </div>
</template>

<script>
import AppDashboardRankPictureColumn
  from "@/views/modules/home/components/rank/components/components/dashboard-rank-picture-column";
import {queryMixin} from "@/minxins";
import {rankMixin} from "@/views/modules/home/components/rank/components/mixin";
import {getNegativeRank} from "@/api/dashboard";
import {mapGetters} from "vuex";

export default {
  name: "app-dashboard-negative-rank",
  components: {AppDashboardRankPictureColumn},
  mixins: [queryMixin, rankMixin],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  data() {
    return {
      rankName: 'negativeMogul',
      tableData: [],
      columns: [
        {id: 'index', header: '排名', field: 'slot:index', width: '60px'},
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '80px', options: () => this.marketOption},
        {id: 'picture', header: '图片', field: 'slot:picture', width: '60px'},
        {id: 'title', header: '商品标题', field: 'title', minWidth: '300px', overflowLine: 2},
        {id: 'asin', header: 'slot:asin', field: 'slot:asin', width: '140px', align: 'right'},
        {id: 'fulfillment', header: '渠道', field: 'option:fulfillment', width: '70px', options: () => this.fulfillmentOption},
        {id: 'starLevel', header: '星级', field: 'starLevel',  align: 'right', width: '60px'},
        {id: 'salesGrossProfit', header: '销售毛利', field: 'salesGrossProfit',prefix: 'currencySymbol', align: 'right', width: '100px'},
        {id: 'salesGrossProfitRate', header: '销售毛利率', field: 'slot:salesGrossProfitRate', suffix:'%', align: 'right', width: '100px'},
        {id: 'salesNetProfit', header: '净毛利', field: 'salesNetProfit', prefix: 'currencySymbol',align: 'right', width: '100px'},
        {id: 'salesNetProfitRate', header: '净毛利率', field: 'salesNetProfitRate',suffix:'%', align: 'right', width: '100px'},
      ],
    }
  },
  methods: {
    //异步获取父asin展开数据
    loadChildrenMethod ({ row }) {
      return getNegativeRank({
        currency: this.dashboardCurrency,
        groupType: 'asin',
        month:this.month,
        variationAsin: row.variationAsin,
        marketIds: row.marketId
      })
    },
    $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      // 查询
      this.loading = true;
      getNegativeRank({
        currency: this.dashboardCurrency,
        groupType: this.type,
        month:this.month,
        countrys: this.countryMarket.countryIds.join(','),// 国家
        marketIds: this.countryMarket.marketIds.join(','),// 店铺
      })
          .then((data) => {
            this.tableData = data || [];
            if(this.type === 'variationAsin'){
              this.tableData.forEach((r,index)=>{
                r.hasChild = true;
              })
            }
          })
          .complete(() => this.loading = false);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "common";
/deep/ .vxe-table--render-default .vxe-cell{
  padding-left: 10px;
}
</style>